module.exports = __webpack_public_path__ + "static/media/room.1c37ca36.svg";